module.exports = __webpack_public_path__ + "img/brand_report.81d2c641.svg";